import React, { useState, useEffect } from "react";

const TestBoard = () => {

  const data = [
    { id: 1, title: "First Item", description: "This is the first item." },
    { id: 2, title: "Second Item", description: "This is the second item." },
    { id: 3, title: "Third Item", description: "This is the third item." },
  ];

  const [currentIndex, setCurrentIndex] = useState(0); 
  const [showButton, setShowButton] = useState(false); 

  useEffect(() => {
  
    if (!showButton) {
      const timer = setTimeout(() => {
     
        if(currentIndex === data.length - 1)
          {
            setShowButton(false); 
          }
          else{
            setShowButton(true); 
          }
      }, 3000);

      return () => clearTimeout(timer); 
    }
  }, [showButton]);

  const handleNext = () => {
    setShowButton(false); 
    if (currentIndex < data.length ) {
      setCurrentIndex((prevIndex) => prevIndex + 1); 
    }


  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
    

      {showButton ? (
        <button onClick={handleNext} style={{ marginTop: "20px", padding: "10px 20px" }}>
          Continue
        </button>
      ):
      (
        <>
        <h1>{data[currentIndex].title}</h1>
        <p>{data[currentIndex].description}</p>
        </> 
      )}
    </div>
  );
};

export default TestBoard;
